import mutations from './treatmentCount.mutations'
import actions from './treatmentCount.actions'
import getters from './treatmentCount.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
